import React from 'react'
import { Container, Alert, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'

interface EntityResolverErrorProps {
  entityName: string
  error: Error
}

export const EntityResolverError: React.FC<EntityResolverErrorProps> = ({
  entityName,
  error,
}) => {
  return (
    <Container className="mt-4">
      <Alert variant="danger">
        <Alert.Heading>Entity Not Found</Alert.Heading>
        <p>
          Could not find entity with name: <strong>{entityName}</strong>
        </p>
        <p className="mb-0">Error: {error.message}</p>
      </Alert>

      <div className="mt-3">
        <p>Possible reasons:</p>
        <ul>
          <li>The entity name was typed incorrectly</li>
          <li>The entity does not exist in the system</li>
          <li>You don't have permission to access this entity</li>
        </ul>
      </div>

      <div className="mt-4">
        <Button as={Link} to="/inventory" variant="primary">
          Back to Inventory
        </Button>
      </div>
    </Container>
  )
}
